var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GeneralSystems/Checkmark/Secondary/32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4-Recalls",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recall_2.9_Mobile_No-Recalls",
    transform: "translate(-14.000000, -842.000000)",
    fill: "#008200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GeneralSystems/Checkmark/Secondary/32",
    transform: "translate(13.000000, 841.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,1 C21.9558441,1 28,7.04415588 28,14.5 C28,21.9558441 21.9558441,28 14.5,28 C7.04415588,28 1,21.9558441 1,14.5 C1,7.04415588 7.04415588,1 14.5,1 Z M20.5159375,7.75 L11.8050625,16.4280965 L8.479,13.1121029 L6.0625,15.5238857 L11.8050625,21.25 L22.9375,10.1584585 L20.5159375,7.75 Z",
    id: "Checkmark"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmark);
export default __webpack_public_path__ + "static/media/green-checkmark.0090d5a34a71a8c23a8dd653d42cd73e.svg";
export { ForwardRef as ReactComponent };